import { createArray, createCell } from 'helpers';
import * as PIXI from 'pixi.js';
import * as setup from 'setup';
import Danger from './Danger';

export default class DangerMagnifier extends Danger {

    textureAnchor = new PIXI.Point(0.4, 0.8);
    textureAutoRotate = false;

    constructor(gameState: GameState, props?: DangerProps, state?: any) {
        super(gameState, 'magnifier', setup.dangers.magnifier, {
            ...props,
            attackingTextures: createArray(9, i => `danger/magnifier/danger-magnifier-attacking-${i + 1}.png`),
            movingTextures: null,
        }, state);
    }

    init = () => {
        this.findTarget();
    }

    findTarget = () => {
        // Get any closest Ant
        const paradiseCell = createCell(setup.foods.cheese.x, setup.foods.cheese.y);
        const antTargets = [
            ...this.gameState.entities.ants.explorers.active,
            ...this.gameState.entities.ants.warriors.active,
            ...this.gameState.entities.ants.workers.active,
        ]
            .filter(ant => ant.getDistanceTo(paradiseCell) > 5)
            .slice(5);
        const targets = [
            ...antTargets,
            ...this.gameState.entities.dangers.antWarriors.active,
            ...this.gameState.entities.dangers.antWorkers.active,
        ];
        this.target = this.getClosestTarget(targets, this.setup.searchDistance);

        // If close enough, attack, otherwise move again
        if (this.target && this.getDistanceTo(this.target.cell) <= 1) {
            this.attackTarget(this.target, this.findTarget);
            this.playSound('danger-magnifier');
        } else if (this.target) {
            this.moveTo(this.target.cell, 0, this.findTarget);
        } else if (this.kills) {
            this.wanderTo(this.cell, 0, this.findTarget);
        } else {
            const cell = createCell(setup.map.cells.wide / 2, setup.map.cells.wide / 2);
            this.wanderTo(cell, 0.8, this.findTarget);
        }
    }

}